import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';
import queryString from 'query-string';

export default function getOrderHistory(options) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, pageNumber, pageSize, dateFrom, dateTo, langId } = options;

    invariant(baseUrl, 'baseUrl is a required param of getOrderHistory()');
    invariant(brandId, 'brandId is a required param of getOrderHistory()');
    invariant(country, 'country is a required param of getOrderHistory()');
    invariant(uberToken, 'uberToken is a required param of getOrderHistory()');
    invariant(clientId, 'clientId is a required param of getOrderHistory()');
    invariant(pageNumber, 'pageNumber is a required param of getOrderHistory()');
    invariant(pageSize, 'pageSize is a required param of getOrderHistory()');
    invariant(dateFrom, 'dateFrom is a required param of getOrderHistory()');
    invariant(dateTo, 'dateTo is a required param of getOrderHistory()');

    const headers = { 'Content-Type': 'application/json' };
    const urlQueryString = queryString.stringify({ pageNumber, pageSize, dateFrom, dateTo, langId });

    let url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/orderhistory/v2/@history?${urlQueryString}`;

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers) }), uberToken, clientId, clientSecret), 'getOrderHistory');
}
